import type { FormFieldModuleContext } from '@/forms/field-modules/registry';
import { fieldModuleRegistry } from '@/forms/field-modules/registry';
import type {
  FormConditionalValidation,
  FormField,
  FormInitialValues,
  FormValidations,
} from '../typings';

export const generateFormFieldValuesAndValidations = (
  field: FormField,
  values: FormInitialValues,
  validations: FormValidations,
  conditions?: FormConditionalValidation[],
): { initialValues: FormInitialValues; validationFields: FormValidations } => {
  const ctx: FormFieldModuleContext = {
    recurse: generateFormFieldValuesAndValidations,
  };

  const mod = fieldModuleRegistry.get(field.type);
  return mod.buildInitialState(field, values, validations, conditions, ctx);
};
